import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const footerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.1 }
    );
    if (footerRef.current) observer.observe(footerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={footerRef}
      className={`
        pt-[10%] md:pt-[5%]
        transition-all duration-700
        ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}
      `}
    >
      <h1 className="text-4xl font-bold">{t('footer.title')}</h1>
      <div className="flex flex-start pt-[2%] flex-wrap">
        <div className="flex-grow min-w-[250px] pr-[1%] pl-[1%]">
          <h1 className="text-2xl font-bold pt-[3%]">{t('footer.schedule.title')}</h1>
          <div className="grid grid-cols-2 gap-y-1 gap-x-0 ">
            <p>{t('footer.schedule.monday')}</p>
            <p>{t('footer.schedule.hours')}</p>
            <p>{t('footer.schedule.tuesday')}</p>
            <p>{t('footer.schedule.hours')}</p>
            <p>{t('footer.schedule.wednesday')}</p>
            <p>{t('footer.schedule.hours')}</p>
            <p>{t('footer.schedule.thursday')}</p>
            <p>{t('footer.schedule.hours')}</p>
            <p>{t('footer.schedule.friday')}</p>
            <p>{t('footer.schedule.hours')}</p>            
          </div>
        </div>
        <div className="flex flex-col flex-grow min-w-[250px] pr-[1%] pl-[1%]">
          <h1 className="text-2xl font-bold pt-[5%]">{t('footer.address.title')}</h1>
          <p>{t('footer.address.street')}</p>
          <h1 className="text-2xl font-bold pt-[5%]">{t('footer.contacts.title')}</h1>
          <p>{t('footer.contacts.phone')}: +39 06 7886902</p>
          <p><a target="blank" aria-label={t('footer.contacts.whatsappAriaLabel')} href="https://wa.me/393898226214">{t('footer.contacts.whatsapp')}: +39 389 8226214</a></p>
        </div>        
      </div>
      <iframe
        title="Odontoiatria Sgarbini"
        className="w-[100%] h-[450px] mt-[10%] md:mt-[5%]  rounded-md"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5941.7162922581765!2d12.521928012479961!3d41.87439837112238!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132f61f75149b9a9%3A0x8764e7bf4465138c!2sStudio%20Sgarbini!5e0!3m2!1sen!2sit!4v1742067960946!5m2!1sen!2sit"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
      <div className="flex flex-col items-center pt-[5%] pb-[5%]">
        <p className="pt-2 text-sm text-center text-pretty text-font-midGrey">
          {t('footer.copyright')}
        </p>
        <p className="pt-2 pb-2 text-xs text-font-midGrey">
          {t('footer.poweredBy')}{" "}
          <a
            href="https://www.linkedin.com/in/elioscipioni/"
            target="_blank"
            rel="noopener noreferrer"
          >
            elscipio.cloud
          </a>
        </p>
      </div>
    </div>
  );
}

export default Footer;
